var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCheckboxTrue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbol_5_1",
    "data-name": "Symbol 5 \\u2013 1",
    transform: "translate(-1016 -2025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    d: "M4 0h16a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
    className: "cls-1",
    "data-name": "Path 109",
    transform: "translate(1016 2025)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Symbol_3_4",
    "data-name": "Symbol 3 \\u2013 4",
    transform: "translate(99.727 248.292)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    d: "M7294.165 1447.724l4.455 3.87 7.306-7.867",
    className: "cls-2",
    "data-name": "Path 76",
    transform: "translate(-6371.986 341.586)"
  })))));
}
export default __webpack_public_path__ + "static/media/ic_checkbox_true.faa8525e.svg";
export { SvgIcCheckboxTrue as ReactComponent };